import { call, put, select } from 'redux-saga/effects';
import { Messages } from '../../../../codegen/Localize';

import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { MoveContentAction } from '../../../../ts/services/MoveContentAction';
import { IResultWithDestinationProject } from '../../../../ts/services/MoveToProjectAction';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { removeFromContentSelection } from '../../../actions/spaces/ContentExplorerSelectionActions';
import { MoveContentsAction, moveContentsSucceeded } from '../../../actions/spaces/MoveContentsAction';
import { requestSpaceContents } from '../../../actions/spaces/RequestSpaceContentsActions';
import { selectSpaceInfo } from '../../../selectors/ContentSelectors';
import { ServiceLocator } from '../../../ServiceLocator';
import { replaceDatasourceIdWithConnectionIdForMixedContent } from '../SpacesSagaHelpers';
import { reloadSpaceIfUpdatingCurrentSpace } from './RefreshContentSagas';

export function openMoveContentDialog(content: IContentInfo[]): ng.IPromise<IResultWithDestinationProject> {
  const moveModule = ServiceLocator.get<MoveContentAction>('MoveContentAction');
  const context = ServiceLocator.getAngularActionContext();
  return moveModule.confirmMoveContent(content, context);
}

export function* handleMoveContentAction(action: MoveContentsAction) {
  try {
    const mutableContentCopy = yield call(replaceDatasourceIdWithConnectionIdForMixedContent, action.contentArray);
    yield call(openMoveContentDialog, mutableContentCopy);
    yield put(removeFromContentSelection(...action.contentArray));

    const didReload = yield call(reloadSpaceIfUpdatingCurrentSpace, action.contentArray);
    if (!didReload) {
      yield put(requestSpaceContents());
    }
    yield put(moveContentsSucceeded());
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}
